import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { COMMON_CONSTANTS_SETTING } from 'src/app/common/constants/common-constants';
import { AuthenticationService } from 'src/app/common/services/authentication.service';
import { SnapshotService } from 'src/app/modules/snapshot/Services/snapshot.service';
import { CrosstabService } from 'src/app/common/services/crosstab.service';
import { LoaderService } from 'src/app/common/services/loader.service';

@Component({
  selector: 'app-setting',
  templateUrl: './setting.component.html',
  styleUrls: ['./setting.component.css'],
})
export class SettingComponent implements OnInit {
  settingOptions = COMMON_CONSTANTS_SETTING;
  isreportIssue: boolean = false;
  @Input() moduleName: string = '';
  @Input() docClick!: boolean;
  @Input() hasDocuments: boolean = false;
  @Input() handleDocumentClick!: () => void;

  @Input() helpGuide: boolean = false;
  SettingList: any = [];

  @Output() OnSettingClick = new EventEmitter<string>();
  constructor(
    private _authenticateService: AuthenticationService,
    private _snapshotService: SnapshotService,
    private _crosstabService: CrosstabService,
    private _loaderService: LoaderService
  ) {}

  settingSlide = false;

  ngOnInit() {
    this.filterSettingsByModule();
    setTimeout(() => (this.settingSlide = true), 300);
  }

  filterSettingsByModule() {
    // Filter settings based on module
    if (
      this.moduleName === 'snapshot' ||
      this.moduleName === 'customsnapshot'
    ) {
      // Show all settings including Snapshot Views for snapshot modules
      this.SettingList = [
        {
          iconClass: 'exportDownloadIcon',
          displayLabel: 'Export Downloads',
          value: this.settingOptions.ExportDownload,
          hasAccess: false,
        },        
        {
          iconClass: 'reportIssueIcon',
          displayLabel: 'Report An Issue',
          value: this.settingOptions.ReportIssue,
          hasAccess: false,
        },
        { 
          iconClass: "helpcircle", 
          displayLabel: "Document Repository", 
          value: this.settingOptions.DocumentRepository, 
          hasAccess: this.docClick,
          disabled: !this.hasDocuments
        },
        {
          iconClass: 'logoutIcon',
          displayLabel: 'Log Out',
          value: this.settingOptions.Logout,
          hasAccess: false,
        },
      ];
    } else {
      // For other modules (crosstab, brandanalysis), exclude Snapshot Views
      this.SettingList = [
        {
          iconClass: 'exportDownloadIcon',
          displayLabel: 'Export Downloads',
          value: this.settingOptions.ExportDownload,
          hasAccess: false,
        },
        {
          iconClass: 'reportIssueIcon',
          displayLabel: 'Report An Issue',
          value: this.settingOptions.ReportIssue,
          hasAccess: false,
        },
        {
          iconClass: 'helpcircle',
          displayLabel: 'Document Repository',
          value: this.settingOptions.DocumentRepository,
          hasAccess: this.docClick,
          disabled: !this.hasDocuments
        },
        {
          iconClass: 'logoutIcon',
          displayLabel: 'Log Out',
          value: this.settingOptions.Logout,
          hasAccess: false,
        },
      ];
    }

    if (this.helpGuide) {
      this.SettingList.unshift({
        iconClass: 'user-guide',
        displayLabel: 'Help Guide',
        value: this.settingOptions.HelpGuide,
        hasAccess: false,
      });
    }
  }

  onToggleSettingSlide(item: string, isDowanload: boolean = false, event: MouseEvent) {
    if (item == this.settingOptions.HelpGuide && isDowanload) {
      event.stopPropagation();
      this.downloadHelpGuide();
    } else {
      if (item == 'logout') {
        this._authenticateService.logout();
      }
      if (
        item == 'snapshotViews' &&
        (this.moduleName === 'snapshot' || this.moduleName === 'customsnapshot')
      ) {
        window.open(
          'https://www.figma.com/proto/7fV2UmWwIX7XJPGLDPoyk3/Explorer--Snapshot-Visuals?page-id=0%3A1&node-id=95-4612&viewport=3126%2C1977%2C0.23&t=HYEZhoeaEEp2zyIq-8&scaling=contain&content-scaling=fixed&starting-point-node-id=95%3A4612&hide-ui=1',
          '_blank'
        );
      }
      if(item == this.settingOptions.DocumentRepository){
         this.handleDocumentClick();
      }
        this.settingSlide = false;
        // Wait for the animation to complete before emitting
        setTimeout(() => this.OnSettingClick.emit(item), 300);
      }

  }

  downloadHelpGuide(): void {
    this._loaderService.showLoader();
    if (this.moduleName === 'crosstab' || this.moduleName === 'brandanalysis' || this.moduleName === 'alert') {
      this._crosstabService.downloadHelpGuide(this.moduleName).subscribe((blob) => {
        let fileName: string;

        switch (this.moduleName) {
          case 'crosstab':
            fileName = 'Explorer+_Crosstab_Help Guide.pdf';
            break;
          case 'brandanalysis':
            fileName = 'Explorer+_BrandAnalysis_Help Guide.pdf';
            break;
          default:
            fileName = 'Explorer+_AlertManagement_Help Guide.pdf'; 
        }

        this._snapshotService.downloadFile(blob, fileName, 'application/pdf');
        this._loaderService.hideLoader();
      });
    }else {
      this._snapshotService.downloadHelpGuide().subscribe((blob) => {
        this._snapshotService.downloadFile(blob, 'Explorer+_Snapshot_Help Guide.pdf', 'application/pdf');
        this._loaderService.hideLoader();
      });
    }
  }
}
